import ReactOnRails from 'react-on-rails/client';
import ResultsDataScrambles from '../../app/ResultsDataScrambles.js';

ReactOnRails.register({ResultsDataScrambles});